import { render, staticRenderFns } from "./signalnew.vue?vue&type=template&id=13ae97a3&scoped=true&"
import script from "./signalnew.vue?vue&type=script&lang=js&"
export * from "./signalnew.vue?vue&type=script&lang=js&"
import style0 from "./signalnew.vue?vue&type=style&index=0&id=13ae97a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ae97a3",
  null
  
)

export default component.exports